import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Canvas({ as, className, children, ...rest }) {
    const Component = as ?? "div";
    return (_jsx(Component, { className: classNames("cvr-canvas", className), ...rest, children: children }));
}
